import { render, staticRenderFns } from "./AccountOrderDetailsInfo.vue?vue&type=template&id=1bc2ed2e&"
import script from "./AccountOrderDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetailsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports